import {
  PERSONAL_MCP_FILTERABLE_FIELDS as MCP_FILTERABLE_FIELDS,
  personalStatusLabels,
  type PersonalMCPFilterableField as MCPFilterableField,
} from '@kirin/api-client/contracts/account-mcp';
import {
  PLATFORM_IDS,
  type PlatformId,
} from '@kirin/api-client/contracts/platform-registry';
import { collapseOptionsByLabel } from '@/components/DataTable/hooks/collapseOptionsByLabel';
import type { FilterOption } from '@/components/DataTable/types';
import {
  typeLabels,
  transportLabels,
  sourceLabels,
} from '@/components/shared/mcp';

export const MCP_TABLE_CONFIG = {
  tableId: 'user-inv-mcp',
  defaultOperator: 'includes',
} as const;

/**
 * Maps each filterable MCP column to its URL state persistence key.
 *
 * `satisfies` enforces full coverage at compile time — adding a new
 * MCPFilterableField without a URL key here will be a type error.
 */
export const MCP_FILTER_URL_KEYS = {
  [MCP_FILTERABLE_FIELDS.NAME]: 'n',
  [MCP_FILTERABLE_FIELDS.VERSION]: 'v',
  [MCP_FILTERABLE_FIELDS.PUBLISHER]: 'pub',
  [MCP_FILTERABLE_FIELDS.TYPE]: 'ty',
  [MCP_FILTERABLE_FIELDS.TRANSPORT]: 'tr',
  [MCP_FILTERABLE_FIELDS.SOURCES]: 'sr',
  [MCP_FILTERABLE_FIELDS.TOOLS]: 'to',
  [MCP_FILTERABLE_FIELDS.RUNNING_COUNT]: 'rc',
  [MCP_FILTERABLE_FIELDS.FIRST_SEEN_AT]: 'fs',
  [MCP_FILTERABLE_FIELDS.LAST_SEEN_AT]: 'ls',
} as const satisfies Record<MCPFilterableField, string>;

export const MCP_TYPE_OPTIONS = Object.entries(typeLabels).map(
  ([value, label]) => ({ value, label })
);

export const MCP_TRANSPORT_OPTIONS = Object.entries(transportLabels).map(
  ([value, label]) => ({ value, label })
);

// Any platform can host an MCP server; gate the full registry by the released set.
// Platforms that share a display name (copilot and github_copilot_cli) become
// one choice. mergedValues lets that choice select every stored id.
export function buildMcpSourceOptions(
  releasedPlatforms: ReadonlySet<PlatformId>
): FilterOption[] {
  return collapseOptionsByLabel(
    PLATFORM_IDS.filter(id => releasedPlatforms.has(id)).map(id => ({
      value: id,
      label: sourceLabels[id],
    }))
  );
}

export const MCP_STATUS_OPTIONS = Object.entries(personalStatusLabels).map(
  ([value, label]) => ({ value, label })
);
